export default {
  root: {
    color: '#333333',
  },
};
